import { Component, ChangeDetectionStrategy } from '@angular/core'
import { SettingsHomeComponent } from './settings-home/settings-home.component'
import { IonNav } from '@ionic/angular'

@Component({
  selector: 'app-settings',
  templateUrl: './settings-page.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [IonNav],
})
export class SettingsPageComponent {
  root = SettingsHomeComponent
}
